export const checkDecorationSVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
    <path
      d="M9 1H10C14.4183 1 18 4.58172 18 9C18 13.4183 14.4183 17 10 17H9C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1Z"
      fill="#19AD79"
      stroke="white"
      stroke-width="2"
    />
    <path
      d="M5.86117 9.17091L7.90708 11.2367L13.1438 6L14 6.8562L7.90708 12.9292L5 10.0221L5.8562 9.16592L5.86117 9.17091Z"
      fill="white"
    />
  </svg>
);
